export default __webpack_public_path__ + "static/media/img-0547-denmark-full-face.1af14846.png";